import type { WorkspaceModule } from '@/lib/api/endpoints/workspaces';
import { MODULE_ALIASES, getModuleMeta, type Module } from '@/types/modules';
import { isRecord } from '@/features/chat/utils/chat-text';

export function toChatModuleFromWorkspaceModule(
  workspaceModule: WorkspaceModule,
  conversationId: string,
  positionOverride?: number,
): Module {
  const rawConfig = isRecord(workspaceModule.config) ? { ...workspaceModule.config } : {};
  const explicitObjectType = typeof rawConfig.__objectType === 'string'
    ? rawConfig.__objectType as Module['objectType']
    : undefined;
  const explicitObjectTypes = Array.isArray(rawConfig.__objectTypes)
    ? rawConfig.__objectTypes.filter((value): value is Module['objectType'] => typeof value === 'string')
    : undefined;
  const color = typeof rawConfig.__color === 'string' ? rawConfig.__color : undefined;
  const accentColor = typeof rawConfig.__accentColor === 'string' ? rawConfig.__accentColor : undefined;
  delete rawConfig.__objectType;
  delete rawConfig.__objectTypes;
  delete rawConfig.__color;
  delete rawConfig.__accentColor;

  const canonicalType = (MODULE_ALIASES[workspaceModule.type as keyof typeof MODULE_ALIASES] ?? workspaceModule.type) as Module['type'];
  const moduleMeta = getModuleMeta(canonicalType);

  const nextModule: Module = {
    id: workspaceModule.id,
    conversation_id: conversationId,
    type: canonicalType,
    label: workspaceModule.label || 'Module',
    position: typeof positionOverride === 'number'
      ? positionOverride
      : (workspaceModule.position ?? 0),
    size: (workspaceModule.size as Module['size']) ?? 'normal',
    config: rawConfig as unknown as Module['config'],
    archived: Boolean(workspaceModule.archivedAt),
    objectType: explicitObjectType ?? moduleMeta?.primaryObjectType,
    objectTypes: (explicitObjectTypes ?? moduleMeta?.objectTypes) as Module['objectTypes'],
    color,
    accentColor,
  };

  return nextModule;
}
